export enum TextThemes {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  DRAG = 'drag'
}

export enum BodyTypes {
  BODYP = 'body-p',
  BODYSPAN = 'body-span',
  SMALLBODYP = 'small-span',
  SMALLBODYSPAN = 'small-p'
}

export enum ActionType {
  ROUTER = 'router',
  EXTERNAL = 'external',
  NEWTAB = 'newtab',
  PHONE = 'phone',
  EMAIL = 'email',
  ONCLICK = 'onclick'
}

export enum ActionStyle {
  TEXT = 'text',
  INLINE_TEXT = 'inlineText',
  ICON = 'icon',
  STYLED_ICON = 'styledIcon',
  BUTTON = 'button',
  IMAGE = 'image'
}

export enum ButtonStyle {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  DESTRUCTIVE = 'destructive',
  PILL = 'pill',
  SMALL_PILL = 'smallPill',
  TOUCHPOINT = 'touchpoint',
  SELECTOR = 'selector',
  SELECTOR_TOGGLE = 'selectorToggle'
}

export enum ButtonWidth {
  FULL,
  FULL_AT_MOBILE,
  FULL_AT_QUOTE_CARD,
  AUTO
}

export enum IconSide {
  LEFT = 'left',
  RIGHT = 'right'
}

export enum TextLinkStyle {
  DEFAULT = 'default',
  FOOTER_NAV_LINK = 'footer-nav-link',
  WARNING_LINK = 'warning-link',
  MOBILE_NAV_LINK = 'mobile-nav-link'
}
